var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13.1243V16.2493H3.74999V13.1243H1.66666V16.2493C1.66666 17.3952 2.60416 18.3327 3.74999 18.3327H16.25C17.3958 18.3327 18.3333 17.3952 18.3333 16.2493V13.1243H16.25ZM15.2083 8.95768L13.7396 7.48893L11.0417 10.1764V1.66602H8.95832V10.1764L6.26041 7.48893L4.79166 8.95768L9.99999 14.166L15.2083 8.95768Z",
    fill: "#0076CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.42fab7ee92c54a594ae164a164220774.svg";
export { ForwardRef as ReactComponent };